import { z } from 'zod'

import { actionItemSchema } from 'shared/api/common/schemas/actionItem'
import { applicationTriggerSchema } from 'shared/api/common/schemas/applicationTrigger'
import { sourceItemSchema } from 'shared/api/common/schemas/sourceItem'

export const accountApplicationsSchemas = {
  getAppAction: {
    request: z.undefined(),
    response: z.object({ action: actionItemSchema }),
    query: z.object({ app_id: z.number(), action_name: z.string() }),
    path: z.undefined(),
  },
  loadAppSource: {
    request: z.undefined(),
    response: z.object({ source: z.array(sourceItemSchema) }),
    query: z.object({
      app_id: z.number(),
      source_name: z.string(),
      group: z.string().or(z.number()).optional(),
    }),
    path: z.undefined(),
  },
  fetchApplicationsTriggers: {
    request: z.undefined(),
    response: z.object({ apps: z.array(applicationTriggerSchema) }),
    query: z.undefined(),
    path: z.undefined(),
  },
  getAppActions: {
    request: z.undefined(),
    response: z.object({
      actions: z.array(
        z
          .object({
            title: z.string(),
            name: z.string(),
            description: z.string(),
          })
          .or(z.void()),
      ),
    }),
    query: z.object({ app_id: z.number() }),
    path: z.undefined(),
  },
}
